import { BUY_SELL_TYPE_LABEL_TEXT_FN_MAP } from '@webtrader/core/constants/order';
import { getOrderBuySellType, mapOrderTypeToText } from '@webtrader/core/format/order';
import { TMixpanelProperties } from '@webtrader/core/mix-panel/types';
import { EMixpanelProperties } from '@webtrader/core/services/analysis/constants';

import { IMixpanelChartTrackingProps } from '../../chart/type';
import { getMixpanelSLTPType } from './utils';

class ChartTrackingHelper {
  public createChartTrackingProperties = ({
    symbol,
    orderId,
    orderType,
    SLTPType
  }: IMixpanelChartTrackingProps): TMixpanelProperties => {
    return {
      [EMixpanelProperties.SYMBOL]: symbol ?? '-',
      [EMixpanelProperties.ORDER_ID]: orderId ?? '-',
      [EMixpanelProperties.ORDER_TYPE]:
        orderType !== undefined || orderType !== null ? mapOrderTypeToText(orderType) : '-',
      [EMixpanelProperties.DIRECTION]: BUY_SELL_TYPE_LABEL_TEXT_FN_MAP[getOrderBuySellType(orderType)](),
      [EMixpanelProperties.SLTP_TYPE]: getMixpanelSLTPType(SLTPType) ?? '-'
    };
  };
}

const chartTrackingHelper = new ChartTrackingHelper();
export default chartTrackingHelper;
